import React from 'react';
import { Box, Button, Center, Image, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface ErrorPageProps {
  title: string;
  description: string;
  imageSrc: string;
  onRetry: () => void;
  relative?: boolean;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  title,
  description,
  imageSrc,
  onRetry,
  relative = false
}) => {
  const { t } = useTranslation('common');
  return (
    <Center height={relative ? '100%' : '100vh'}>
      <VStack justify="center" align="center" px="25px" gap="0">
        <Image h="25vh" src={imageSrc} />
        <Box h="30px"></Box>
        <Text fontSize="18px" fontWeight="500">
          {t(title)}
        </Text>
        <Box h="5px"></Box>
        <Text fontSize="15px" color="text.sub" textAlign="center">
          {t(description)}
        </Text>
        <Box h="15px"></Box>
        <Button colorScheme="primary" px="24px" onClick={onRetry}>
          {t('retry').toUpperCase()}
        </Button>
      </VStack>
    </Center>
  );
};

export default ErrorPage;
